import React from "react";

function useToggleControlled(value, setter, defaultValue = false) {
  const { current: controlled } = React.useRef(value !== undefined);

  const [state, setState] = React.useState(defaultValue);

  const toggle = React.useCallback(() => {
    setState((prev) => !prev);
  }, []);

  if (controlled) {
    return [value, setter];
  }

  return [state, toggle];
}

export default useToggleControlled;
